<lib-ags-loading *ngIf="!apprenantData"></lib-ags-loading>

<div
  *ngIf="!!apprenantData"
  class="uk-card uk-card-default uk-margin-large-right uk-margin-medium-bottom"
  style="margin-top: 15px"
>
  <div class="uk-card-header uk-padding-small uk-background-muted">
    <div class="uk-width-expand">
      <h3 class="uk-card-title uk-margin-remove-bottom uk-text-meta uk-text-uppercase uk-text-muted">
        Apprenant(s)
      </h3>
    </div>
  </div>
  <div class="uk-card-body uk-padding-remove">
    <kendo-grid [data]="apprenantData">
      <ng-template kendoGridNoRecordsTemplate>
        Pas d'apprenant(s) pour cette session
      </ng-template>
      <kendo-grid-column field="civilite" title="Civilité"> </kendo-grid-column>
      <kendo-grid-column field="nom" title="Nom"> </kendo-grid-column>
      <kendo-grid-column field="prenom" title="Prénom"> </kendo-grid-column>
      <kendo-grid-column field="date_naissance" title="Date de naissance">
        <ng-template kendoGridCellTemplate let-apprenantData>
          {{ apprenantData.date_naissance | date: 'dd/MM/yyyy' }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="matricule" title="Matricule"> </kendo-grid-column>
      <kendo-grid-column field="nom_client" title="Client"> </kendo-grid-column>
      <kendo-grid-column class="mouse-clickable">
        <ng-template kendoGridCellTemplate let-apprenantData>
          <button
            kendoButton
            class="colored-text primary-background"
            style="margin-left: .2rem; margin-right: .3rem;"
            [primary]="true"
            (click)="open(apprenantData)"
          >
            <span class="small material-icons ">edit</span>
          </button>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </div>
</div>

<!-- Popup Edit Apprenant -->
<div class="example-wrapper">
  <kendo-dialog [title]="titleDialog" *ngIf="opened" (close)="close()" [minWidth]="250" [width]="1000">
    <ng-container *ngTemplateOutlet="contentDialog"></ng-container>
  </kendo-dialog>
  <ng-template #contentDialog>
    <!-- Tout ce qu'il y a à l'intérieur de la pop-up -->
    <form [formGroup]="apprenantForm" action="#" (ngSubmit)="handleFormApprenant($event)">
      <table style="width: 100%">
        <tr uk-grid>
          <td class="uk-width-4-5">
            <div>
              <p>Civilité</p>
              <label>
                <input name="civilite" class="input-radio" type="radio" value="monsieur" formControlName="civilite" />
                <span class="checkbox-civ">Monsieur</span>
              </label>
              <br />
              <label class="margin-top-10">
                <input name="civilite" class="input-radio" type="radio" formControlName="civilite" value="madame" />
                <span class="checkbox-civ">Madame</span>
              </label>
            </div>
          </td>
          <td class="uk-width-1-5">
            <div>
              <img class="img_profil" src="{{ apprenantForm.value.photo }}" />
            </div>
          </td>
        </tr>
        <tr uk-grid>
          <td class="uk-width-1-4">
            <div class="form-input">
              <label for="nom">
                <input
                  id="nom"
                  name="apprenantData.nom"
                  type="text"
                  class="uk-input input-border input-border"
                  formControlName="nom"
                  required
                />
                <span class="placeholder">Nom</span>
              </label>
            </div>
            <div
              *ngIf="submitedForm && apprenantForm.controls['nom'].errors"
              class="invalid-feedback-value"
              [@alertDisplay]=""
            >
              Format invalide
            </div>
          </td>
          <td class="uk-width-1-4">
            <div class="form-input">
              <label for="nomNaissance">
                <input
                  id="nomNaissance"
                  name="apprenantData.nom_naissance"
                  type="text"
                  class="uk-input input-border input-border"
                  formControlName="nom_naissance"
                />
                <span class="placeholder">Nom de naissance</span>
              </label>
            </div>
          </td>
          <td class="uk-width-1-4">
            <div class="form-input">
              <label for="prenom">
                <input
                  id="prenom"
                  type="text"
                  class="uk-input input-border input-border"
                  formControlName="prenom"
                  required
                />
                <span class="placeholder">Prénom</span>
              </label>
            </div>
            <div
              *ngIf="submitedForm && apprenantForm.controls['prenom'].errors"
              class="invalid-feedback-value"
              [@alertDisplay]=""
            >
              Format invalide
            </div>
          </td>
          <td class="uk-width-1-4">
            <div class="form-input">
              <label for="matricule">
                <input formControlName="matricule" id="matricule" type="text" class="uk-input input-border" />
                <span class="placeholder">Matricule</span>
              </label>
            </div>
          </td>
        </tr>
        <tr uk-grid>
          <td class="uk-width-1-4">
            <div class="form-input">
              <label for="date_naissance">
                <input
                  [value]="chossedApprenant.date_naissance | date: 'yyyy-MM-dd'"
                  formControlName="date_naissance"
                  id="date_naissance"
                  type="date"
                  class="uk-input input-border"
                />
                <span class="placeholder">Date de naissance</span>
              </label>
            </div>
          </td>
          <td class="uk-width-1-4">
            <div class="form-input">
              <label for="villenaissance">
                <input
                  formControlName="ville_naissance"
                  id="villenaissance"
                  type="text"
                  class="uk-input input-border"
                />
                <span class="placeholder">Ville de naissance</span>
              </label>
            </div>
          </td>
          <td class="uk-width-1-4 hauteur">
            <label for="departement">Département de naissance</label>
            <select id="departement" class="uk-select input-border margin" formControlName="id_dpt_naissance">
              <option value="" disabled selected>Choisissez un département</option>
              <option *ngFor="let elm of departementList | async" [value]="elm.id">{{ elm.libelle }}</option>
            </select>
          </td>
          <td class="uk-width-1-4 hauteur">
            <label for="paysNaissance">Pays de naissance</label>
            <select id="paysNaissance" class="uk-select input-border margin" formControlName="pays_naissance">
              <option value="" disabled selected>Choisissez un pays de naissance</option>
              <option *ngFor="let elm of pays | async" [value]="elm.id">{{ elm.nom_fr }}</option>
            </select>
          </td>
        </tr>
        <tr uk-grid>
          <td class="uk-width-1-4">
            <div class="form-input">
              <label for="telephone">
                <input formControlName="telephone" id="telephone" type="text" class="uk-input input-border" />
                <span class="placeholder">Téléphone</span>
              </label>
            </div>
          </td>
          <td class="uk-width-1-4">
            <div class="form-input">
              <label for="adressemail">
                <input formControlName="adresse_mail" id="adressemail" type="text" class="uk-input input-border" />
                <span class="placeholder">Adresse mail</span>
              </label>
            </div>
          </td>
          <td class="uk-width-1-4">
            <div class="form-input">
              <label for="observation">
                <input formControlName="observation" id="observation" type="text" class="uk-input input-border" />
                <span class="placeholder">Observations</span>
              </label>
            </div>
          </td>
          <td class="uk-width-1-4 hauteur">
            <div class="uk-margin">
              <label class="uk-form-label" for="type">Type</label>
              <div class="uk-form-controls margin">
                <select formControlName="id_type" id="type" name="select-type" class="uk-select form-select">
                  <option value="" selected>Sélectionnez un type</option>
                  <option *ngFor="let elm of typeApprenentList | async" [value]="elm.id">{{ elm.libelle }}</option>
                </select>
              </div>
            </div>
          </td>
        </tr>
        <tr uk-grid>
          <td class="uk-width-1-4">
            <div class="form-input">
              <label for="adresse">
                <input formControlName="adresse" id="adresse" type="text" class="uk-input input-border" />
                <span class="placeholder">Adresse</span>
              </label>
            </div>
          </td>
          <td class="uk-width-1-4">
            <div class="form-input">
              <label for="codepostal">
                <input formControlName="cp" id="codepostal" type="text" class="uk-input input-border" />
                <span class="placeholder">Code postal</span>
              </label>
            </div>
          </td>
          <td class="uk-width-1-4">
            <div class="form-input">
              <label for="ville">
                <input formControlName="ville" id="ville" type="text" class="uk-input input-border" />
                <span class="placeholder">Ville</span>
              </label>
            </div>
          </td>
          <td class="uk-width-1-4 hauteur">
            <label for="pays">Pays</label>
            <select id="pays" class="uk-select input-border margin" formControlName="id_pays">
              <option value="" disabled selected>Choisissez un pays</option>
              <option *ngFor="let elm of pays | async" [value]="elm.id">{{ elm.nom_fr }}</option>
            </select>
          </td>
        </tr>
      </table>

      <br />
      <div
        *ngIf="errorServer"
        [@alertDisplay]=""
        class="invalid-feedback-value k-text-center font-size-100"
        role="alert"
      >
        <strong>Impossible</strong> de modifier l'information, veuillez réessayer plus tard.
      </div>
      <kendo-dialog-actions>
        <button class="k-primary k-button" kendoButton type="submit">Valider</button>
      </kendo-dialog-actions>
    </form>
  </ng-template>
</div>
